import AldetreScoreFooter from "src/modules/medcard/cards/modify-aldetre-score/footer";
import CapriniRiskAssessmentFooter from "../../caprini-risk-assessment/footer";
import PediatricTraumaScoreFooter from "../../pediatric-trauma-score/footer";
import PrismScoreFooter from "../../prism-score/footer";
import ImproveVteRiskAssessmentFooter from "../../improve-vte-risk-assessment/footer";
import FallRiskHarizmiFooter from "../../fall-risk-harizmi/footer";
import FallRiskItakiFooter from "../../fall-risk-itaki/pages/footer";
import CanScaleFooter from "../../can-scale/footer";
import EdineburghDeptScaleFooter from "../../edineburgh-dept-scale/footer";

function CardFooter() {
  const urlParams = new URLSearchParams(window.location.search);
  const searchCardName = urlParams.get("cardName") || "";

  const getCardNameFromPath = (pathname: string): string => {
    const parts = pathname.split("/");
    const medcardIndex = parts.findIndex((p) => p === "medcard");
    if (medcardIndex >= 0 && parts[medcardIndex + 1]) {
      const cardPath = parts[medcardIndex + 1];
      return cardPath.toUpperCase().replace(/-/g, "_");
    }
    return "";
  };

  const cardName =
    searchCardName || getCardNameFromPath(window.location.pathname);


  if (!cardName) return null;

  if (cardName === "ALDETRE_SCORE") return <AldetreScoreFooter />;
  if (cardName === "PEDIATRIC_TRAUMA_SCORE") return <PediatricTraumaScoreFooter />;
  if (cardName === "CAPRINI_RISK_ASSESSMENT") return <CapriniRiskAssessmentFooter />;
  if (cardName === "PRISM_SCORE") return <PrismScoreFooter />;
  if (cardName === "IMPROVE_VTE_RISK_ASSESSMENT") return <ImproveVteRiskAssessmentFooter />;
  if (cardName === "FALL_RISK_HARIZMI") return <FallRiskHarizmiFooter />;
  if (cardName === "FALL_RISK_ITAKI") return <FallRiskItakiFooter />;
  if (cardName === "CAN_SCALE") return <CanScaleFooter />;
  if (cardName === "EDINEBURGH_DEPT_SCALE") return <EdineburghDeptScaleFooter />;

  return null;
}

export default CardFooter;